const ToolbarContainer = ( props ) => (
	<div
		className="editor-format-toolbar"
	>
		{ props.children }
	</div>
);
export default ToolbarContainer;
